module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image4-4aa5c4695cb6313814a06fe10c9e6ba0.png";